import { Box, Typography, styled } from '@mui/material';

export const TitleWrapper = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  flexShrink: 0,
});

export const Title = styled(Typography)(({ theme }) => ({
  width: '100%',
  fontWeight: 500,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  [theme.breakpoints.down('sm')]: {
    width: '45vw',
  },
}));

export const MobileDuration = styled(Typography)(({ theme }) => ({
  fontSize: 12,
  color: theme.palette.grey[400],
  [theme.breakpoints.up('sm')]: {
    display: 'none',
  },
}));
